import type { DeepPartial } from "@tandemdiabetes/sugarmate-api-react-client"
import {
  useSaveAccountMedication as useSaveAccountMedicationApi,
  useCreateAccountMedication,
} from "@tandemdiabetes/sugarmate-api-react-client"
import { useCallback } from "react"
import type { DeepReadonlyObject } from "rxdb"

import { transformAccountMedication } from "./transformAccountMedication"
import {
  useCreateCollectionItem,
  useUpdateCollectionItem,
} from "src/hooks/rxdb"
import { CollectionKey } from "src/types"
import type { AccountMedication } from "src/types"

type PartialAccountMedication = DeepReadonlyObject<DeepPartial<AccountMedication>>

export function useSaveAccountMedication() {
  const createAccountMedication = useCreateCollectionItem(
    CollectionKey.AccountMedication,
    "account_med",
    useCreateAccountMedication,
    transformAccountMedication,
  )

  const updateAccountMedication = useUpdateCollectionItem(
    CollectionKey.AccountMedication,
    "account_med",
    useSaveAccountMedicationApi,
    transformAccountMedication,
  )

  return useCallback(
    (accountMedication: PartialAccountMedication) => {
      const {
        id,
        med_id,
        ...otherProps
      } = accountMedication

      if (id) {
        return updateAccountMedication({
          ...accountMedication,
          id: Number(id),
          med_id: med_id ? Number(med_id) : null,
        })
      }

      return createAccountMedication({
        ...otherProps,
        med_id: med_id ? Number(med_id) : null,
      })
    },
    [
      createAccountMedication,
      updateAccountMedication,
    ],
  )
}
